import script from "./NodoComponente.vue?vue&type=script&lang=ts&setup=true"
export * from "./NodoComponente.vue?vue&type=script&lang=ts&setup=true"

import "./NodoComponente.vue?vue&type=style&index=0&id=60e836d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e836d9"]])

export default __exports__